export default __webpack_public_path__ + "static/media/doctor.650fb01d.jpg";